"use client";

import { useState, useEffect } from "react";
import { getCookie } from "@/lib/cookie-utils";
import type { User } from "@/types/auth";

/**
 * Client-side hook to check auth state from cookies
 */
export function useAuthUser() {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const updateAuthState = () => {
      const token = getCookie("santafe_conecta_token");
      const userData = getCookie("santafe_conecta_user");

      if (token && userData) {
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
          setIsAuthenticated(true);
        } catch {
          setUser(null);
          setIsAuthenticated(false);
        }
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }

      setIsLoading(false);
    };

    // Initial check
    updateAuthState();

    // Listen for storage events (for multi-tab sync)
    window.addEventListener("storage", updateAuthState);

    // Check periodically for cookie changes
    const interval = setInterval(updateAuthState, 1000);

    return () => {
      window.removeEventListener("storage", updateAuthState);
      clearInterval(interval);
    };
  }, []);

  return { user, isAuthenticated, isLoading };
}
